module.exports = __webpack_public_path__ + "img/KH.9467ef4b.svg";